var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19980_1409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4021 5.07243L9.26859 0.938941C8.01475 -0.311678 5.98527 -0.311678 4.73142 0.938941L0.597932 5.07243C0.213808 5.45451 -0.00149608 5.97436 7.82594e-06 6.51618V12.57C0.00129298 13.3602 0.641901 14.0003 1.43211 14.0009H12.5679C13.3581 14.0003 13.9987 13.3602 14 12.57V6.51618C14.0015 5.97436 13.7862 5.45451 13.4021 5.07243ZM12.25 12.2509H9.33334V10.3947C9.33334 9.16472 8.3362 8.16757 7.10617 8.16757H6.89385C5.66382 8.16757 4.66668 9.16472 4.66668 10.3947V12.2509H1.75V6.51618C1.7502 6.43882 1.78077 6.36467 1.83518 6.30968L5.96867 2.17619C6.53811 1.60659 7.46147 1.60648 8.03107 2.17591C8.03115 2.176 8.03126 2.17611 8.03134 2.17619L12.1648 6.30968C12.2192 6.36467 12.2498 6.43882 12.25 6.51618V12.2509H12.25Z",
    fill: "#67686D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19980_1409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d4260ca1d7860772c2a442a85bc149dc.svg";
export { ForwardRef as ReactComponent };